<template>
    <div class="wrap">
        <div class="containter">
            <type-menu ref="typeMenu" :menu="tabs" :type-id="typeId" :sub-type-id="subTypeId"
                @getList="getList"></type-menu>
            <div class="content">
                <div class="c-header">
                    <div class="header-group-left">
                        <el-button type="primary" size="mini" @click="open">上传</el-button>
                        <el-button type="danger" size="mini" :disabled="!delAccess" @click="delAll">删除</el-button>
                        <!-- <el-dropdown>
                            <el-button type="default" plain size="mini"> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>批量删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                    </div>
                    <div class="header-group-right">
                        <div>
                            <el-input placeholder="请输入内容" v-model="query.keyword" class="input-with-select" size="mini">
                                <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                            </el-input>
                        </div>
                    </div>
                </div>

                <div class="c-header">
                    <el-checkbox :value="checked" @change="checkAll">全选</el-checkbox>
                </div>

                <div class="c-main">
                    <div class="overflow-container">
                        <div class="card">
                            <div class="card-item" v-for="item in list" :key="item._id">
                                <div class="card-item__img">
                                    <el-image :src="item.cover" :preview-src-list="[item.cover]"> </el-image>
                                </div>
                                <div class="card-detail">
                                    <div class="card-detail__name">{{ item.title }}</div>
                                    <!-- <div class="card-detail__info">
                                        <span>大小: 7666M</span>
                                        <span>创建人: 杭裔</span>
                                    </div> -->
                                    <div class="card-detail__time">更新: {{ item.updatedAt }}</div>
                                </div>
                                <div class="card-control">
                                    <el-checkbox class="checkbox" v-model="item.checked"></el-checkbox>
                                    <!-- <el-button type="text" size="mini" class="el-icon-view eye"></el-button> -->
                                    <el-dropdown @command="handleCommand">
                                        <el-button type="text" size="mini" class="el-icon-more more"></el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                :command="{ type: 'download', data: item }">下载视频</el-dropdown-item>
                                            <el-dropdown-item
                                                :command="{ type: 'copy', data: item }">复制视频地址</el-dropdown-item>
                                            <el-dropdown-item
                                                :command="{ type: 'edit', data: item }">编辑</el-dropdown-item>
                                            <el-dropdown-item
                                                :command="{ type: 'del', data: item._id }">删除</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page">
                        <el-pagination class="" @current-change="handleCurrentChange" :current-page="query.page"
                            :page-sizes="[10, 20, 50, 100]" :page-size="query.pageSize"
                            layout="total, prev, pager, next, jumper" :total="query.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
            <el-form :model="form" ref="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
                <el-form-item label="标题" prop="title" verify>
                    <el-input v-model="form.title" size="small"></el-input>
                </el-form-item>
                <el-form-item label="视频封面" prop="cover" verify>
                    <FaImageUpload v-model="form.cover" :maxCount="1" />
                </el-form-item>
                <el-form-item v-if="!form._id" label="视频" prop="content" verify>
                    <i class="el-icon-warning-outline" style="color: #f56c6c;font-size: 12px;">
                        视频大小不能超过200MB
                    </i>
                    <div class="text-s">
                        <FaUpload ref="faUploadRef" v-model="form.content" :maxCount="1" @hook:mounted="() => {
                            $refs.faUploadRef.filePond.on('init', () => {
                            })
                        }" />
                        
                    </div>
                </el-form-item>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getSubCategories, saveMaterials, delMaterials } from "@/api/material";

import TypeMenu from "@/pages/mall/components/TypeMenu.vue";

export default {
    name: "ImgManage",
    props: {
        typeId: String,
    },
    components: {
        TypeMenu,
    },
    data() {
        return {
            checked: false,
            tabs: [],
            list: [],
            subTypeId: "",
            once: false,
            keyword: "",
            categoryId: "",
            dialogVisible: false,
            dialogTitle: "",
            form: {
                _id: "",
                title: "",
                content: "",
                cover: "",
            },
            query: {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                cover: [
                    { required: true, message: '请输入封面', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '上传文件不能为空!', trigger: 'blur' },
                ]
            }
        };
    },
    computed: {
        delAccess() {
            return this.list.some(item => item.checked === true);
        }
    },
    watch: {
        list: {
            handler(val) {
                if (val.length === 0) {
                    this.checked = false;
                    return
                }
                const tag = val.every((item) => item.checked === true);

            },
            deep: true,
        },
    },
    created() {
        this.initList();
    },
    methods: {
        async initList() {
            this.query = {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: '',
            }
            await this.getList();
        },

        async getList(id) {
            if (id) {
                this.subTypeId = id;
                this.query = {
                    page: 1,
                    total: 0,
                    pageSize: 10,
                    keyword: '',
                }
            }
            const { status, data, message } = await getSubCategories({
                categoryId: this.typeId,
                page: this.query.page,
                pageSize: this.query.pageSize,
                filter: this.query.keyword,
            });
            if (status == 10000) {
                this.tabs = data;
                if (!this.once) {
                    this.subTypeId = this.tabs[0]?._id;
                    this.once = true;
                }
                const subList = data.filter((item) => item._id === this.subTypeId)[0];
                this.query.total = subList.totalPages;
                this.list = subList.materials.map((item) => {
                    return {
                        checked: false,
                        ...item,
                    };
                });
            } else {
                this.$message.error(message);
            }
        },


        handleCurrentChange(page) {
            this.query.page = page;
            this.getList();
        },

        open(data) {
            this.dialogTitle = data?._id ? "编辑素材" : "添加素材";
            this.form = {
                _id: data._id,
                title: data.title,
                content: data.content,
                cover: data.cover,
            };
            this.dialogVisible = true;
        },

        save(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let method = "POST";
                    if (this.form._id) {
                        method = "PUT";
                    }
                    const { status, message } = await saveMaterials(method, {
                        id: this.form._id,
                        title: this.form.title,
                        category: this.typeId,
                        subCategory: this.subTypeId,
                        content: this.form.content[0],
                        cover: this.form.cover,
                    });
                    if (status == 10000) {
                        this.$message({
                            type: "success",
                            message,
                        });
                        this.getList();
                        this.dialogVisible = false;
                    } else {
                        this.$message.error(message);
                    }
                }
            });

        },

        del(ids) {
            this.$confirm("此操作将永久删除该项, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const { status, message } = await delMaterials({
                        id: ids,
                    });
                    if (status == 10000) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getList();
                        this.checked && (this.checked = false);
                    } else {
                        this.$message.error(message);
                    }
                })
                .catch(() => {
                    console.info("已取消删除!");
                });
        },

        copy(url) {
            if (navigator.clipboard && window.isSecureContext) {
                // 在安全域下使用 navigator.clipboard 提升效率
                navigator.clipboard.writeText(url).then(() => {
                    this.$message({
                        type: "success",
                        message: "已复制链接到剪贴板!",
                    });
                }).catch(err => {
                    this.$message.error('出现未知错误');
                    console.error('Failed to copy text to clipboard.', err);
                });
            }
            else {
                // 非安全域退回到 document.execCommand('copy');
                const textarea = document.createElement('textarea');
                textarea.value = url;
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    const successful = document.execCommand('copy');
                    if (successful) {
                        this.$message({
                            type: "success",
                            message: "已复制链接到剪贴板!",
                        });
                    } else {
                        this.$message.error('复制失败');
                    }
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }
                document.body.removeChild(textarea);
            }
        },

        download(url) {
            window.open(url, '_blank');
        },

        delAll() {
            const ids = this.list.filter((item) => item.checked).map((item) => item._id).join(",");
            this.del(ids);
        },

        handleCommand({ type: command, data }) {
            switch (command) {
                case "edit":
                    this.open(data);
                    break;
                case "del":
                    this.del(data);
                    break;
                case "download":
                    this.download(data.content);
                    break;
                case "copy":
                    this.copy(data.content);
                    break;
            }
        },

        checkAll() {
            const tag = !this.checked;
            this.list = this.list.map((item) => {
                return {
                    ...item,
                    checked: tag,
                };
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: 100%;

    .containter {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 8px;

        .content {
            flex: 1 1 auto;
            min-width: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 0 0px 16px;
        }

        .c-header {
            display: flex;
            height: 32px;
            justify-content: space-between;
            align-items: center;

            &:nth-of-type(2n) {
                margin-top: 8px;
            }
        }

        .header-group-left {
            .el-button {
                min-width: 80px;

                &:first-child {
                    margin-right: 8px;
                }
            }
        }

        .c-main {
            position: relative;
            padding: 6px 0 42px;
            height: 100%;
            flex: 1 1 auto;
            min-height: auto;

            .overflow-container {
                height: 100%;
                overflow-y: auto;

                // 滚动条整体样式
                &::-webkit-scrollbar {
                    display: block;
                    width: 6px;
                    height: 6px;
                }

                // 滚动条轨道
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }

                // 滚动条滑块
                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;

                    &:hover {
                        background: #a8a8a8;
                    }
                }
            }

            .page {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                bottom: 0px;
                width: 100%;
            }
        }

        .card {
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
        }

        .card-item {
            display: flex;
            flex-direction: column;
            width: 160px;
            min-height: 200px;
            position: relative;

            &:not(:first-child) {
                margin-bottom: 24px;
                margin-left: 16px;
            }

            &:hover {
                .card-item__img {
                    border: 1px solid #2061e6;
                }
            }

            .card-item__img {
                width: 160px;
                height: 160px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f6f7f8;
                box-sizing: border-box;
                border: 1px solid transparent;

                img {
                    display: block;
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }
            }

            .card-control {
                display: flex;
                align-items: center;
                position: absolute;
                width: 100%;
                top: 0;
                padding: 4px 8px;

                .checkbox {
                    margin-right: auto;
                    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
                }

                .el-button+.el-dropdown {
                    margin-left: 6px;
                }

                .eye,
                .more {
                    padding: 0px;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    color: #8c8c8cad;
                    font-weight: bold;
                    background: #fff;
                    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);

                    &:hover {
                        background: #ededed;
                    }
                }

                .more {
                    font-weight: normal;
                }
            }
        }

        .card-detail {
            padding-top: 8px;

            .card-detail__name {
                font-size: 400;
                color: #333;
            }

            .card-detail__info {
                display: flex;
                justify-content: space-between;
                gap: 10px;

                span {
                    min-width: 72px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            div {
                margin-bottom: 8px;
                font-size: 12px;
                color: #999;
            }
        }
    }
}
</style>
<style>
.filepond--root :not(text) {
    font-size: 16px;
}
</style>